// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { ModuleType, Module, Chapter, Progress, Note } from '../../../types/Model';
import { RootState } from '../../rootReducer';

export const onlineCourseContentsRaw = (state: RootState) => state.onlineCourseContentsDataReducer

/**
 * when fetching, set loading state
 */
export const makeIsFetchingOnlineCourseContentsData = (): Selector<RootState, boolean> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => onlineCourseContentsReducer.isLoading
  );
};

/**
 * when error, set error state
 */
export const makeErrorOnlineCourseContentsData = (): Selector<RootState, any> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => onlineCourseContentsReducer.error
  );
}

/**
 * when select specific content, return the content
 */
export const makeOnlineCourseContentsDataByIdSelector = (id: number): Selector<RootState, Chapter[]> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => {
      return onlineCourseContentsReducer.onlineCourseContents[id] || []
    }
  );
};

/**
 * select the progress data
 */
export const makeOnlineCourseContentsProgressByIdSelector = (id: number): Selector<RootState, Progress[]> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => onlineCourseContentsReducer.onlineCourseProgress[id]
  );
};

/**
 * when select specific content, return the content
 */
export const makeOnlineCourseDataById = (id: number) => {
  return createSelector(
    makeOnlineCourseContentsDataByIdSelector(id),
    (data: Chapter[]) => {
      const result = data.reduce((acc: Module[], cur) => {
        const newAry: Module[] = cur.modules.map((v) => {
          const theObj: any = {
            type: v.type
          };

          if (v.type === ModuleType.VIDEO) {
            theObj.vodId = v.vodId;
            theObj.videoUrls = v.videoUrls;
          } else if (v.type === ModuleType.LAB) {
            theObj.labId = v.labId;
          } else if (v.type === ModuleType.QUIZ) {
            theObj.quizId = v.quizId;
            theObj.examData = v.examData;
            theObj.answers = v.answers;
            theObj.explains = v.explains;
          }

          return theObj;
        });

        return acc.concat(newAry);
      }, []);

      return result;
    }
  );
};

/**
 * when select specific content, return the note
 */
export const makeOnlineCourseNotesDataByIdSelector = (id: number, vodId: number): Selector<RootState, Note[]> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => {
      const list = onlineCourseContentsReducer.onlineCourseNotes[id] || [];
      return list.filter((note:Note) => vodId ? note.vodId === vodId : true);
    }
  );
};

/**
 * when fetching, set loading state
 */
export const makeIsFetchingOnlineCourseNotesData = (): Selector<RootState, boolean> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => onlineCourseContentsReducer.isNotesLoading
  );
};

/**
 * return note error
 */
export const makeNoteErrorOnlineCourseNotesData = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => onlineCourseContentsReducer.noteError
  );
};

/**
 * when select specific content, return the progress
 */
export const makeOnlineCourseProgressDataByIdSelector = (id: number): Selector<RootState, Progress[]> => {
  return createSelector(
    onlineCourseContentsRaw,
    (onlineCourseContentsReducer) => {
      return onlineCourseContentsReducer.onlineCourseProgress[id] || []
    }
  );
};
